import React from 'react'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'

import SupplierContainer from './SupplierContainer'

class SupplierShowPage extends React.Component {
    componentDidMount() {
        document.title = 'Supplier | OSH CRM'
    }

    render () {
      const { match } = this.props
      const { id } = match.params

        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                        { path: '/suppliers', name: 'Suppliers' },
                        { path: `/suppliers/${id}`, name: id }
                    ]}>
                    <ContentLayout>
                      <SupplierContainer supplierId={id} />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default SupplierShowPage
